import { useSelector } from "react-redux";
import { selectAuth, selectUser } from "../redux/auth/selectors.js";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LoaderSvg from "./Loader/LoaderSvg.jsx";

export default function PrivateRoute({
  component: Component,
  redirectTo = "/",
  accessPath = null, // новий проп — шлях для перевірки прав
}) {
  const {
    isLoggedIn,
    apiKey,
    isRefreshing,
    allowRegistrationForm,
    allowThanksForRegistrationPage,
  } = useSelector(selectAuth);

  const userData = useSelector(selectUser); // додати цей селектор
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    if (!isRefreshing) {
      setIsAuthChecked(true);
    }
  }, [isRefreshing]);

  if (isRefreshing || !isAuthChecked) {
    return <LoaderSvg />;
  }

  if (allowRegistrationForm || allowThanksForRegistrationPage) {
    return Component;
  }

  if (!isLoggedIn && !apiKey) {
    return <Navigate to={redirectTo} />;
  }

  if (!isLoggedIn && apiKey) {
    return <Navigate to="/login" />;
  }

  // Перевірка прав доступу до конкретної сторінки
  if (accessPath) {
    const pages = userData?.access_pages ?? [];
    const hasAccess = pages.some(
      item => item.page === accessPath && item.status === 1
    );
    if (!hasAccess) {
      return <Navigate to="/forbidden" replace />;
    }
  }

  return Component;
}
